import styled from '@emotion/styled';

import { Input, Typography } from '@/design-system';

export type ActionReasonValues = {
  reason: string;
  internalReference: string;
};

export const emptyActionReasonValues: ActionReasonValues = {
  reason: '',
  internalReference: '',
};

export const areActionReasonValuesValid = (values: ActionReasonValues) =>
  Boolean(values.reason.trim()) && Boolean(values.internalReference.trim());

const FieldsRoot = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

const Field = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

type ActionReasonFieldsProps = {
  sharedWithLabel: string;
  values: ActionReasonValues;
  onChange: (values: ActionReasonValues) => void;
  disabled?: boolean;
};

export const ActionReasonFields = ({
  sharedWithLabel,
  values,
  onChange,
  disabled,
}: ActionReasonFieldsProps) => (
  <FieldsRoot>
    <Typography variant="body3">Please explain the reason for this action:</Typography>

    <Field>
      <Typography as="label" variant="body3" htmlFor="action-internal-reference">
        Internal Reference (only visible to Gamma Prime)
      </Typography>
      <Input
        id="action-internal-reference"
        placeholder="Enter Here"
        value={values.internalReference}
        onChange={(e) => onChange({ ...values, internalReference: e.target.value })}
        disabled={disabled}
      />
    </Field>

    <Field>
      <Typography as="label" variant="body3" htmlFor="action-shared-reason">
        {sharedWithLabel}
      </Typography>
      <Input
        id="action-shared-reason"
        placeholder="Enter Here"
        value={values.reason}
        onChange={(e) => onChange({ ...values, reason: e.target.value })}
        disabled={disabled}
      />
    </Field>
  </FieldsRoot>
);
